import { useTranslation } from "react-i18next";

import ContactForm from "../../components/Contact/ContactForm/ContactForm";
import ContactItem from "../../components/Contact/ContactItem/ContactItem";

import "./Contact.css";

const Contact = ({ innerRef, title }) => {
	const { t } = useTranslation();
	const contactOptions = t("contact.options", { returnObjects: true });

	return (
		<div id="home-contact" ref={innerRef} className="contact-bg">
			{title === false ? (
				<h1 className="contact-title">
					{t("contact.titleBig")} <br /> {t("contact.titleBig2")}
				</h1>
			) : (
				<h2 className="contact-title">{t("contact.title")}</h2>
			)}

			<div className="contact-grid-container">
				<h4>{t("contact.description")}</h4>
				<div className="contact-grid-items">
					{contactOptions.map((option, index) => (
						<ContactItem
							key={index}
							data={{
								title: option["title"],
								description: option["description"],
								icon: option["image"],
								alt: option["alt"],
							}}
						/>
					))}
				</div>
				<ContactForm />
			</div>
		</div>
	);
};

export default Contact;
